import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TGetForcedToLiveAccountsResponse } from "../../api/funds/index.types";

export interface IForcedToLiveAccountsState {
  accounts: {
    data: TGetForcedToLiveAccountsResponse["data"];
    isLoading: boolean;
  };
}

const initialState: IForcedToLiveAccountsState = {
  accounts: {
    data: {
      count: 0,
      rows: [],
      accountsOver8KWithdrawals: [],
      forcedToLive: [],
    },
    isLoading: false,
  },
};

const forcedToLiveAccountsSlice = createSlice({
  name: "forcedToLiveAccounts",
  initialState,
  reducers: {
    fetchAccountsRequest: (state) => {
      state.accounts.isLoading = true;
    },
    fetchAccountsSuccess: (
      state,
      action: PayloadAction<TGetForcedToLiveAccountsResponse["data"]>
    ) => {
      state.accounts.isLoading = false;
      state.accounts.data = action.payload;
    },
    fetchAccountsFailed: (state) => {
      state.accounts.isLoading = false;
    },
  },
});

export const forcedToLiveAccountsActions = forcedToLiveAccountsSlice.actions;
export default forcedToLiveAccountsSlice.reducer;
